import { render } from "./MiscellaneousComponent.vue?vue&type=template&id=21944f0a"
import script from "./MiscellaneousComponent.vue?vue&type=script&lang=js"
export * from "./MiscellaneousComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__